module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_04_6DE79_1SF_GJ0.caa03582.png";